module.exports = __webpack_public_path__ + "static/media/sm_3.f39430aa.svg";